export default "__VITE_ASSET__Bl5Q7R5K__"